<template>
  <el-row style="height: 390px;width: 100%;margin-top: 20px;">
    <el-row style="width: 100%;height: 70px;">
      <el-row class="hardware-logo" />
    </el-row>
    <el-row style="width: 94%;margin-left: 3%;height: 300px;margin-top: 10px;">
      <el-col v-for="(data, i) in dataList" :key="i" :style="{width: 'calc(100% / 3)', height: 'calc(100% / ' + (dataList.length / 3) + ')'}">
        <el-row v-if="i % 2 === 0" style="width: 100%;height: 100%;">
          <el-row class="hardware-img-box">
            <el-row @click.native="changeRoute('/hardware', data.id)" class="hardware-img" :style="{'background-image': 'url(' + data.img + ')'}"></el-row>
          </el-row>
          <el-row class="hardware-text">{{data.name}}</el-row>
        </el-row>
        <el-row v-else style="width: 100%;height: 100%;">
          <el-row class="hardware-img-box">
            <el-row @click.native="changeRoute('/hardware', data.id)" class="hardware-img" :style="{'background-image': 'url(' + data.img + ')'}"></el-row>
          </el-row>
          <el-row class="hardware-text">{{data.name}}</el-row>
        </el-row>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
export default {
  name: 'Software',
  data() {
    return {
      dataList: [
        {id: '321', name: '智能仪表', img: require('../../assets/img/hardware/yk8220.png')},
        {id: '321', name: '保护装置', img: require('../../assets/img/hardware/baohu.png')},
        {id: '323', name: '智能网关', img: require('../../assets/img/hardware/wangguan.png')},
        {id: '322', name: '智能传感', img: require('../../assets/img/hardware/chuangan.png')},
        {id: '321', name: '负荷识别', img: require('../../assets/img/hardware/yk8400.png')},
        {id: '324', name: '智慧安防', img: require('../../assets/img/hardware/jiankong.png')}
      ]
    }
  },
  methods: {
    changeRoute(path, page) {
      this.$router.push({path: path, query: {page: page}})
    }
  }
}
</script>

<style scoped>
  .hardware-logo {
    background: url("../../assets/hardware.png") no-repeat;
    background-size: 100% 100%;
    width: 70%;
    margin-left: 15%;
    height: 60px;
  }
  .hardware-img-box {
    height: 76%;
    width: 96%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid #bbbbbb;
    box-shadow: 5px 5px rgba(0, 0, 0, 0.06);
    margin-right: 2%;
  }
  .hardware-img {
    width: 100%;
    height: 110px;
    background-size: contain;
    background-repeat: no-repeat;
  }
  .hardware-text {
    width: 90%;
    margin: 6% 0 0 5%;
    height: 18%;
    font-size: 16px;
    font-family: "Microsoft YaHei";
    color: #9fa0a0;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/Hardware.vue